import * as React from 'react';
import { IStaticPageWrapperProps, StaticPageWrapper, centeredMessageStyle } from 'components/static-pages/StaticPageWrapper';

export const ShopWellPage = (props:IStaticPageWrapperProps) => {
	const shopWellUrl = 'https://www.innit.com/shopwell/';
	return (	
		<StaticPageWrapper
			backgroundImage="/res_sys/shopwell_splash.jpg" 
			backgroundSize="cover" 
			{...props}
		>
			<div style={centeredMessageStyle}>
				<div style={{textAlign:'center',fontFamily:'Open Sans',fontWeight:900,fontSize:'32px',color:'#263692', paddingTop:'20px', paddingBottom:'25px',lineHeight: '32px'}}>ShopWell</div>
				<div style={{textAlign:'center', marginTop:'0px', marginBottom:'25px'}}>
					<a target="_blank" href={shopWellUrl} className="go_button" style={{borderRadius:'40px',boxShadow: '2px 2px 4px 0px rgba(0,0,0,0.5)'}}>GET THE APP</a>
				</div>
				<div style={{fontSize:'18px',fontFamily:'Open Sans',fontWeight:600, fontStyle:'italic',color:'#4A4A4A', textAlign:'center',paddingBottom:'30px'}}>
					Eat well... Live Well<br/><br/>
				</div>
			</div>
		</StaticPageWrapper>
	);
};

